import React, { useState, useEffect } from 'react';
import { Cookie } from 'lucide-react';
import { Button } from './ui/button';
import { Link } from 'react-router-dom';

export const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (!cookieConsent) {
      const timer = setTimeout(() => setIsVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleChoice = (choice) => {
    localStorage.setItem('cookieConsent', choice);
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div
      data-testid="cookie-consent-banner"
      className="fixed bottom-0 left-0 right-0 z-50 p-3 md:p-4 bg-white border-t border-gray-200 shadow-2xl animate-slide-up"
    >
      <div className="container mx-auto max-w-6xl">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3 md:gap-6">
          <div className="flex items-start gap-3 flex-1 min-w-0">
            <Cookie className="w-5 h-5 text-blue-700 flex-shrink-0 mt-0.5" />
            <p className="text-xs md:text-sm text-gray-700 leading-relaxed">
              This website uses only technically necessary cookies and browser
              storage required for the site to function. We do not use
              analytics or advertising cookies.{' '}
              <Link
                to="/cookie-policy"
                className="text-blue-700 hover:text-blue-800 underline"
                data-testid="cookie-policy-link"
              >
                Read our Cookie Policy
              </Link>
              .
            </p>
          </div>

          <div className="flex flex-wrap items-center gap-2 flex-shrink-0">
            <Button
              variant="outline"
              size="sm"
              onClick={() => handleChoice('rejected')}
              data-testid="cookie-reject-btn"
              className="border-gray-300 text-gray-700 hover:bg-gray-100 text-xs md:text-sm"
            >
              Reject Non-Essential
            </Button>
            <Link
              to="/cookie-policy"
              data-testid="cookie-settings-link"
              className="text-xs md:text-sm text-blue-700 hover:text-blue-800 underline px-2"
              onClick={() => setIsVisible(false)}
            >
              Cookie Settings
            </Link>
            <Button
              size="sm"
              onClick={() => handleChoice('accepted')}
              data-testid="cookie-accept-btn"
              className="bg-blue-700 hover:bg-blue-800 text-white text-xs md:text-sm"
            >
              Accept
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
